import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";

export default function FarmContacts() {

    const { t } = useTranslation();
    //const { params } = props.match;
    
    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>

                            </ol>
                        </nav>
                    </div>
                </div>
                <div>
                    <div>
                        Contacts
                    </div>
                </div>
                <br />
            </div > : ""}
        </div>
    );
}
